export default __webpack_public_path__ + "static/media/tumorChannel6.97a45b6e.png";